import React, { Fragment } from 'react';
import { format } from 'date-fns';
import { sanitize } from 'dompurify';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';

/**
 * Interaction.
 * @returns {React.component} A single interaction to render.
 */
const Interaction = (props) => {
  // 'm/dd/yy - h:MMTT'
  const timestamp = format(props.interaction.createDate, 'MM/dd/yy - hh:mma');

  // Determine if the comment is blocked.
  const interactionBlocked = props.interaction.approvalStatus === 'BLOCKED';
  const userIgnored = props.interaction.ignored;
  const userBlocked = props.interaction.actingUserBlocked;

  // Determine the alternate text to disply if the comment is blocked.
  let alternateText = '';

  if (interactionBlocked) {
    alternateText = 'This comment has been blocked.';
  }

  if (userIgnored) {
    alternateText = 'You have ignored this user.';
  }

  if (userBlocked) {
    alternateText = 'This user has been blocked.';
  }

  return (
    <li className="interaction-list__item">
      {
        (interactionBlocked || userIgnored || userBlocked) ? (
          <p>{alternateText}</p>
        ) : (
          <Fragment>
            <p className="interaction-list__item-heading">
              <span className="gray">Comment on: </span>
              <a href={props.interaction.topicUrl}>{props.interaction.topicTitle}</a>
            </p>
            <div className="interaction-list__item-body">
              {ReactHtmlParser(sanitize(props.interaction.body))}
            </div>
            <p className="interaction-list__item-timestamp">{timestamp}</p>
          </Fragment>
        )
      }
    </li>
  );
};

/**
 * Validation on passed-in props.
 * @type {Object}
 */
Interaction.propTypes = {
  interaction: PropTypes.shape({
    createDate: PropTypes.number,
    approvalStatus: PropTypes.string,
    ignored: PropTypes.bool,
    actingUserBlocked: PropTypes.bool,
    topicUrl: PropTypes.string,
    topicTitle: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
  }).isRequired,
};

export default Interaction;



// WEBPACK FOOTER //
// ./src/components/Interaction/Interaction.js